import Axios from "axios"
import { useHost } from "global/host.global"

const useAxios = () => {
  const { token, subdomain } = useHost()

  return Axios.create({
    baseURL: `https://${process.env.REACT_APP_API_HOST}`,
    headers: {
      Authorization: `Bearer ${token}`,
      tenant: subdomain,
    },
  })
}

export default useAxios
